import createAccount from 'html/account/create-account.html';
import App from 'app/app.js';
import 'app/service/RouterService.js';
import 'app/service/TranslateProviderService.js';
import 'app/service/ValidationService.js';
import 'app/service/BlockService.js';
import 'app/store/UserProfileStore.js';
import 'app/store/MessageStore.js';

var CREATE_ACCOUNT_PATH = '/create-account';

var CREATE_ACCOUNT_ROUTE_CONFIG = {
  template: createAccount,
  controller: 'CreateAccountCtrl',
  controllerAs: 'createAccountCtrl',
  jobRequired: false,
  orderRequired: false,
  orderFlow: false
};

var RouteProviderConfig = function ($routeProvider) {
  $routeProvider.when(CREATE_ACCOUNT_PATH, CREATE_ACCOUNT_ROUTE_CONFIG);
};

function CreateAccountCtrl(
  $scope,
  BlockService,
  MessageStore,
  RouterService,
  StorageService,
  TranslateProviderService,
  UserProfileStore,
  ValidationService,
  $filter
) {
  this.path = CREATE_ACCOUNT_PATH;
  this.emailOptions = [];
  this.canadianDomain = TranslateProviderService.isCanadianDomain();
  this.canadaEmailOptIn = false;
  this.userProfile = { subscriptions: [] };

  this.init = function () {
    this.userProfile.email = UserProfileStore.userProfile.email;
    if (!this.userProfile.email) {
      return RouterService.goToLogin();
    }
    if (UserProfileStore.isLoggedIn()) {
      return RouterService.goToMyAccount();
    }
  };

  this.isInvalid = function () {
    ValidationService.validateInputLength($scope.createAcctForm.firstName, 1, 32);
    ValidationService.validateInputLength($scope.createAcctForm.lastName, 1, 32);
    ValidationService.validatePasswordIdentity($scope.createAcctForm.password);
    return $scope.createAcctForm.$invalid;
  };

  this.resetErrors = function (field) {
    ValidationService.resetErrors(field);
  };

  this.createAccount = function () {
    if (this.isInvalid()) {
      return;
    }

    BlockService.blockUI();
    UserProfileStore.setUserProfile(this.userProfile);

    var optInText = $filter('ltTranslateFilter')('CREATE_ACCOUNT_EMAIL_OPTIN', {}) || 'CREATE_ACCOUNT_EMAIL_OPTIN';

    if (this.canadianDomain) {
      if (this.canadaEmailOptIn) {
        UserProfileStore.setOptIn(UserProfileStore.UserSubscription.MyFamilyRewards, true, optInText);
      } else {
        UserProfileStore.setOptIn(UserProfileStore.UserSubscription.MyFamilyRewards, false, optInText);
      }
    }

    UserProfileStore.createAccount()
      .then(function (response) {
        if (response.data.success) {
          return UserProfileStore.reloadUserProfile().finally(function () {
            StorageService.set('createAccountFromPopup', true);
            RouterService.redirectAfterAccountCreation();
          });
        }
      })
      .catch(function () {
        MessageStore.createSystem('ACCOUNT_UNKNOWN_ERROR');
      })
      .finally(function () {
        BlockService.unblockUI();
      });
  };

  this.goToChangeAccount = function () {
    RouterService.goToChangeAccount();
  };

  this.getSystemMessages = function () {
    return MessageStore.getSystemMessages();
  };
}

App.controller('CreateAccountCtrl', [
  '$scope',
  'BlockService',
  'MessageStore',
  'RouterService',
  'StorageService',
  'TranslateProviderService',
  'UserProfileStore',
  'ValidationService',
  '$filter',
  CreateAccountCtrl
]);

App.config(['$routeProvider', RouteProviderConfig]);

App.run([
  'RouterService',
  function (RouterService) {
    RouterService.paths.CREATE_ACCOUNT = CREATE_ACCOUNT_PATH;
    RouterService.goToCreateAccount = RouterService.goTo(CREATE_ACCOUNT_PATH);
  }
]);
